<template>
  <div :class="classes">
    <pt-page-title title="积分商品" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <el-button slot="before-left" type="primary" @click="creatGoods" v-if="HAS_GOODS_MANAGEMENT">新建积分商品</el-button>
    </pt-page-title>
          <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter @Filter="Filter" ref="filter">
        <template>
            <el-button type="primary" @click="Filter">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-integral-goods-table :tableLabels="tableLabels" ref="table" :paramsData="paramsData">
        <template>
          <el-table-column label="推荐值">
                <template  slot-scope="scope">
                    <div :class="$style['ranking-div']" @mouseenter="editRanking(scope.row)"   @mouseleave="noEditRank(scope.row)">
                        {{scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.ranking?scope.row.goodsOtherInfoDTO.ranking:0}}
                        <el-popover placement="bottom" trigger="click" v-if="scope.row.isEditRank" @mouseenter="editRanking(scope.row)">
                            <edit-ranking :rowInfo="scope.row.goodsOtherInfoDTO" @sumitRank="sumitRank" fromPage="integral"></edit-ranking>
                            <i class="iconfont icon-bianji"  slot="reference"  @click="editRinkValue(scope.row)"></i>
                        </el-popover>
                    </div>
                </template>
          </el-table-column>
          <!-- <el-table-column label="商城展示">
            <template slot-scope="scope">
               <el-switch :value="scope.row.goodsOtherInfoDTO.mallVisible" @change="mallVisibleChange(scope.row)"></el-switch>
            </template>
          </el-table-column> -->
             <!-- <el-table-column label="首页展示">
                <template slot-scope="scope">
               <el-switch :value="scope.row.goodsOtherInfoDTO.recommend" @change="recommendChange(scope.row)"></el-switch>
            </template>
             </el-table-column> -->
            <el-table-column label="置顶">
              <template slot-scope="scope">
                    <el-switch :value="scope.row.goodsOtherInfoDTO.sticky" @change="stickyChange(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="商品状态">
                <template  slot-scope="scope">
                    {{scope.row.goods_state}}
                </template>
            </el-table-column>
           <el-table-column label="操作" min-width="120" fixed="right">
               <template slot-scope="scope">
                   <div :class="$style['opreation-button']">
                       <template v-if="HAS_GOODS_MANAGEMENT">
                            <i class="iconfont icon-bianji"  @click="editGoods(scope.row)"></i>
                            <i class="iconfont icon-shanchu" v-if="!notDeleteRow(scope.row)"  @click="deleteGoods(scope.row)"></i>
                            <!-- <i class="iconfont icon-tuijian"
                            :class="[scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.recommend?'main-color':'']" @click="recommendGoods(scope.row)"></i> -->
                            <el-button type="text" v-if="scope.row.goodsDTO.state=='DRAFT'" @click="submit(scope.row)">提交</el-button>
                        </template>
                        <el-button type="text" @click="goodsDetail(scope.row)">详情</el-button>
                   </div>
               </template>
           </el-table-column>
        </template>
      </pt-integral-goods-table>
  </div>
</template>

<script>
// 组件class前缀
import { goodsTableLabel, filterLabels } from './integral-goods-option'
import editRanking from 'cps/mall-manage/pt-goods-manage/edit-ranking'
import { hasPermissions } from 'utils/permissions'
import ptIntegralGoodsTable from './pt-integral-goods-table/withData'
const prefixCls = 'pt-goods-of-integral'
const PERM_MALL_GOODS_MANAGEMENT = 'PERM_P_001'// 商品管理权限
export default {
  name: 'pt-goods-of-integral',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_GOODS_MANAGEMENT () {
      return hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_MALL_GOODS_MANAGEMENT)
    }
  },
  components: {
    ptIntegralGoodsTable,
    editRanking
  },
  props: {
    goodsTypes: Array,
    goodsGroup: Array
  },
  watch: {
    goodsTypes: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'type') item.options = val
        })
      },
      deep: true
    },
    goodsGroup: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'groupId') item.options = val
        })
      },
      deep: true
    }
  },
  data () {
    return {
      searchKey: null,
      filterLabels: filterLabels,
      tableLabels: goodsTableLabel,
      isFromRouter: false,
      params: {},
      paramsData: {},
      isEditRank: false
    }
  },
  methods: {
    // 已上架商品不能被删除
    notDeleteRow (val) {
      return val.goodsDTO && val.goodsDTO.state && val.goodsDTO.state === 'PUBLISHED'
    },
    editGoods (row) {
      this.$router.push('/integral-goods-form/true/' + row.goodsDTO.id)
    },
    deleteGoods (row) {
      this.$confirm('您是否确定删除该商品', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('goodsDelete', row.goodsDTO.id)
      })
    },
    submit (val) {
      this.$confirm('您是否提交该商品', '提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('integralGoodsApproval', val.goodsDTO.id)
      })
    },
    goodsDetail (row) {
      this.$router.push('/integral-goods-detail/' + row.goodsDTO.id)
    },
    mallVisibleChange (val) {},
    recommendChange (val) {
      let text = val.goodsOtherInfoDTO.recommend ? '取消该商品的首页展示' : '将该商品展示在首页'
      this.$confirm('您是否确定' + text, '首页展示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('recommendChange', val)
      })
    },
    stickyChange (val) {
      let text = val.goodsOtherInfoDTO.sticky ? '取消置顶该商品' : '置顶该商品'
      this.$confirm('您是否确定' + text, '置顶', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('stickyChange', val)
        // if (val.goodsOtherInfoDTO.sticky) {
        //   this.$emit('cancelStick', val)
        // } else {
        //   this.$emit('setStick', val)
        // }
      })
    },
    noEditRank (val) {
      if (!val.isedit) {
        this.$set(val, 'isEditRank', false)
      }
    },
    editRanking (val) {
      this.$set(val, 'isEditRank', true)
      val.isEditRank = true
    },
    editRinkValue (val) {
      this.$set(val, 'isedit', true)
      this.$set(val, 'isEditRank', true)
      this.row_now = val
    },
    sumitRank () {
      this.$set(this.row_now, 'isEditRank', false)
      this.getTableData()
    },
    search (val) {
      this.isFromRouter = false
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    creatGoods () {
      this.$router.push('/integral-goods-form/false/0')
    },
    // 筛选数据处理
    paramsDeal (isFromRouter) {
      if (!isFromRouter) {
        this.searchKey = null
        if (this.params.searchKey) {
          this.$delete(this.params, 'searchKey')
        }
      }
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'publishTime' || key === 'priceInterval') {
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsDeal(isFromRouter)
      this.paramsData = { ...{ sortWay: 'RECOMMEND_DESC' }, ...this.params }
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    cleanParams () {}
  },
  created () {

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    display: block;
    :global
    i{
        margin-right: 10px;
    }
}
</style>
